module.exports = __webpack_public_path__ + "img/5253_SCS Wheel logo redesign_F.55832c89.png";